import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/** The user guide, built from docs/user-guide into public/help. */
export function HelpPage() {
  return (
    <Stack spacing={2} component="section" aria-label="Help">
      <Typography variant="h5" component="h2">
        Help
      </Typography>
      <Box
        component="iframe"
        title="AVGV user guide"
        src="/help/index.html"
        sx={{
          width: "100%",
          height: "calc(100vh - 180px)",
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          bgcolor: "#fff",
        }}
      />
    </Stack>
  );
}
